// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"UV-z","inlineTitle":"VV-z","sponsoredAdsWrapper":"WV-z","marketplaceRecosWrapper":"XV-z"};